export default "__VITE_ASSET__DqsTyO9P__"